export const GRIFFIN_REQUEST_BASEURL = 'txp/api/v1.0/me/{0}';
export const GRIFFIN_REQUEST_ID_URL_FORMAT = '{0}({1}){2}';
export const ADD_REMOVE_OR_EDIT_URL_PREFIX = 'Messages';
export const SHARE_EVENT_URL_PREFIX = 'Events';
export const ADD_TO_CALENDAR_RELATIVEPATH = '/AddTailoredExperienceEventsToCalendar';
export const REMOVE_FROM_CALENDAR_RELATIVEPATH = '/RemoveTailoredExperienceEventsFromCalendar';
export const SHARE_EVENT_RELATIVEPATH = '/ShareTailoredExperienceEvent';
export const SAVE_USER_EDITED_ENTITY_DATA = '/SaveUserEditedEntityData';
export const POST_NEW_USER_VOICE_SUGGESTION = 'PostNewUserVoiceSuggestion';
export enum ResponseStatus {
    Error = 'Error',
    Success = 'Success',
}
